import type { useVehicleTyreActions } from '../hooks/use-vehicle-tyre-actions';
import { TyreMoveModal } from './TyreMoveModal';

/** The fit, replace or rotate a person started from one of a vehicle's positions. */
export function VehicleTyreMoveModal({ actions }: { actions: ReturnType<typeof useVehicleTyreActions> }) {
  return (
    <TyreMoveModal
      kind={actions.action?.kind ?? null}
      subject={actions.subject}
      error={actions.move.error}
      submitting={actions.move.saving}
      positionOptions={actions.rotateOptions}
      rotation={actions.rotation}
      onSubmit={actions.submit}
      onClose={actions.close}
    />
  );
}
